import axios from 'axios';
import { CARE_STUDIO_MIDDLEWARE_URL } from '../../constants/Configs';
import { CRM_PUBLIC_BASE_URL } from '../../constants/Configs';
import BaseService from '../../utils/BaseService';

export const getMeetingToekn = (meetingObj: any) => {
  const axios = BaseService.getSharedInstance().axios;
  return axios.get(
    `/crm-communication/meetms/meeting/${meetingObj?.id}/client_token${
      meetingObj.role ? `?role=${meetingObj.role}` : ''
    }`,
    {
      headers: {
        'user-uuid': meetingObj.userUuid,
        'account-uuid': meetingObj?.accountUUID || meetingObj?.appointmentDetails?.accountUUID
      },
    }
  );
};
export const getClienttoken = (meetingObj: any) => {
  const axios = BaseService.getSharedInstance().axios;
  return axios.get(
    `/crm-communication/meetms/meeting/${meetingObj?.meetingId}/client_token${
      meetingObj.role ? `?role=${meetingObj.role}` : ''
    }`,
    {
      headers: {
        'user-uuid': meetingObj.userUuid,
        'account-uuid': meetingObj?.accountUUID || meetingObj?.appointmentDetails?.accountUUID
      },
    }
  );
};
export const getClientHostToken = (meetingObj: any) => {
  const axios = BaseService.getSharedInstance().axios;
  return axios.get(
    `/crm-communication/meetms/meeting/${meetingObj?.meetingId}/client_token?role=role-doc`,
    {
      headers: {
        'user-uuid': meetingObj?.joineeDetails?.userUuid,
        'account-uuid': meetingObj?.accountUUID || meetingObj?.appointmentDetails?.accountUUID
      },
    }
  );
};

export const updateJoinMeetingDetails = (meetingObj: any) => {
  const axios = BaseService.getSharedInstance().axios;
  return axios.post(
    `/crm-communication/meetms/meeting/join`,
    {
      participantId: meetingObj.participantId,
      meetingId: meetingObj.meetingId,
      name: meetingObj.name,
    },
    {
      headers: {'user-uuid': meetingObj?.joineeDetails?.userUuid},
    }
  );
};


export const getAppointmentDetailById = (appointmentDetailQuery: any, accountUuid: string) => {
  const foldAccessToken = localStorage.getItem('foldAccessToken') ?? ''; 
  return axios.post(CARE_STUDIO_MIDDLEWARE_URL, appointmentDetailQuery, {
    headers: {
      'account-uuid': accountUuid,
      fold_access_token: foldAccessToken,
    }
  });
}

export const getCareStudioMlovs = (mlovQuery: any, accountUuid: string) => {
  const foldAccessToken = localStorage.getItem('foldAccessToken') ?? ''; 
  return axios.post(CARE_STUDIO_MIDDLEWARE_URL, mlovQuery, {
    headers: {
      'account-uuid': accountUuid,
      fold_access_token: foldAccessToken,
    }
  });
}

export const getThemeConfigData = (accountId: any, subDomain: string) => {
  const axios = BaseService.getSharedInstance().axios;
  return axios
    .post(
      CRM_PUBLIC_BASE_URL + `/getAccountThemes`,
      JSON.stringify({subDomain: subDomain}),
      {
        headers: {
          'x-hasura-account-id':
            accountId,
        },
      }
    )
}

export const getShortLink = async (link: string) => {
  const axios = BaseService.getSharedInstance().axios;
  const body = {longLink: link};
  const result = await axios.post(CRM_PUBLIC_BASE_URL + `/shortLink`, body);
  return result?.data?.shortLink || link;
};
